import { C } from '@/shared/ui/theme/tokens';

interface FaceFrameProps {
  size: number;
  active: boolean;
}

export function FaceFrame({ size, active }: FaceFrameProps) {
  const cx = size / 2, cy = size / 2;
  const rx = size * 0.37, ry = size * 0.44;
  const cl = 28, sw = 3;
  const color = active ? C.primary : 'rgba(255,255,255,.4)';

  const corners = [
    `M${cx - rx + cl} ${cy - ry} L${cx - rx} ${cy - ry} L${cx - rx} ${cy - ry + cl}`,
    `M${cx + rx - cl} ${cy - ry} L${cx + rx} ${cy - ry} L${cx + rx} ${cy - ry + cl}`,
    `M${cx - rx} ${cy + ry - cl} L${cx - rx} ${cy + ry} L${cx - rx + cl} ${cy + ry}`,
    `M${cx + rx} ${cy + ry - cl} L${cx + rx} ${cy + ry} L${cx + rx - cl} ${cy + ry}`,
  ];

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', zIndex: 2 }}
    >
      <ellipse
        cx={cx} cy={cy} rx={rx} ry={ry}
        fill="none" stroke={color} strokeWidth={1.5}
        strokeDasharray="8 5" strokeOpacity=".55"
      />
      {corners.map((d, i) => (
        <path
          key={i}
          d={d}
          fill="none"
          stroke={color}
          strokeWidth={sw}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ animation: active ? `mi-corner-pulse 2s ease-in-out ${i * 0.3}s infinite` : 'none' }}
        />
      ))}
    </svg>
  );
}
